<ng-container>
  <div class="tw-pt-4 tw-px-4" (click)="handleQuizBannerClick()">
    <div class="tw-w-full tw-relative tw-flex tw-justify-between tw-gap-[6px] xs:tw-gap-4 tw-rounded-3 tw-shadow-z4 tw-bg-white">
      <div class="tw-pl-4 tw-pb-4">
        <h1 class="tw-pt-9 tw-font-lexend -tw-tracking-[1.5px] tw-font-bold tw-text-black" [class]="getDailyCareTitleClasses()" i18n="@@dailyCare">Daily Care</h1>
        <h1 class="tw-font-lexend tw-text-[#7A5198] tw-font-bold" [class]="getQuizTitleClasses()" i18n="@@quiz">Quiz</h1>
        <p class="tw-text-[#828282] tw-text-[11px] xxs:tw-text-200 tw-font-body tw-mt-1" i18n="@@playAndEarnCureskinCash">Play and earn Cure cash daily</p>
      </div>

      <div class="tw-w-[36%] tw-max-w-40 tw-self-end tw-rounded-r-3 tw-overflow-hidden tw-mb-2">
        <img src='/assets/images/rebrandedQuizBannerImage.gif' class="tw-w-full tw-h-auto" />
      </div>

      <div class="tw-absolute tw-w-10 tw-aspect-square tw-rounded-full tw-left-4 -tw-top-4 tw-flex tw-justify-center tw-items-center">
        <img src="/assets/images/rebrandedQuizBannerIcon.png"/>
      </div>
    </div>
  </div>
</ng-container>
